<template>
    <v-container class="pa-2">
 <template>
    <v-card class="mt-0">
    <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
          <v-spacer/>
        <v-btn
        icon
        @click="showFilters = !showFilters"
      >
        <v-icon>{{ showFilters ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
        </v-card-title>
     <v-expand-transition>
      <div v-show="showFilters">

       <v-card-text>
          <v-row>
            <v-col cols="12" sm="4">
            <v-select
                v-model="invoicingPeriodYear"
                :items="uniqueInvoiceYears"
                label="Έτος χρήσης"
                prepend-icon="mdi-calendar"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
            <v-select
              v-model="invoicingPeriodMonth"
              :items="months"
              label="Μήνας"
              prepend-icon="mdi-calendar-month"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4" v-if="invoicingPeriodYear || invoicingPeriodMonth">
              <v-chip class="ma-2" color="primary" outlined>
                <v-icon left>mdi-currency-eur</v-icon>
                {{ fiDate }}
              </v-chip>
            </v-col>
          </v-row>
        </v-card-text>
      </div>
    </v-expand-transition>
    </v-card>
    </template>
    
  <template>
  <v-card class="mt-4"
    :loading="loading"
    >
   
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Τιμολόγια</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="invoices"
      :search="search"
      loading: false
      sort-by="Date"
      sort-desc
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
      @current-items="getFilteredInvoices"
    >

     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          :to="{name: 'distributor-order-checkin', params: {invoiceId: item.Id}}"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
         <!-- <v-icon v-if="item.LineItems.length==0">mdi-basket-fill</v-icon>
         <v-icon v-else>mdi-basket</v-icon> -->
         <v-btn
          icon
          v-if="[3].includes(item.PaymTerm.Term)"
          @click.stop="createPayment(item)"
         >
         <v-icon>mdi-cash</v-icon>
        </v-btn>
         <v-btn
          icon
          v-if="[1, 2, 4, 5,6,7].includes(item.PaymTerm.Term)"
          @click.stop="createPaymentAdmin(item)"
         >
         <v-icon>mdi-credit-card</v-icon>
        </v-btn>
     </template>

     <template v-slot:item.NetValue="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.NetValue) }}
    </template>
    <template v-slot:item.TotalValue="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.TotalValue) }}
    </template>
    <template v-slot:item.VatValue="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.VatValue) }}
    </template>
    
     <template v-slot:body.append="{headers}">
        <tr>
            <td v-for="(header,i) in headers" :key="i">

                <div class="text-right" v-if="header.value == 'TotalValue'">
                    Σύνολο: {{ 
                    $tocurr(
                      $sumField(filteredInvoices.filter(e=>!['5.1', '5.2'].includes(e.InvoiceType)), 'TotalValue')
                    - $sumField(filteredInvoices.filter(e=>['5.1', '5.2'].includes(e.InvoiceType)), 'TotalValue')
                    ) 
                    }}
                </div>

                <div v-else>
                    <!-- empty table cells for columns that don't need a sum -->
                </div>

            </td>
        </tr>
    </template>
    
    
<!--     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.DocNumber }}<br>
        <v-simple-table
            fixed-header
            height="200px"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    SKU
                  </th>
                  <th class="text-left">
                    Qty
                  </th>
                  <th class="text-left">
                    Retail Price
                  </th>
                  <th class="text-left">
                    Price
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="line in item.LineItems"
                  :key="line.id"
                >
                  <td>{{ line.SupplierSku }}</td>
                  <td>{{ line.Qty }}</td>
                   <td>{{ tocurr(line.RetailPrice) }}</td>
                  <td>{{ tocurr(line.PartCost) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        
      </td>
    </template>
  -->


    </v-data-table>
  </v-card>
</template>
<v-snackbar
   timeout=2500
   v-model="snackbar"
   multi-line>
      {{ snackText }}
  </v-snackbar>

    </v-container>
</template>

<script>
import { clone as _clone } from 'lodash'

export default {
  computed: {
   uniqueInvoiceYears () {
      // console.log("asdsd: ", this.uniq(this.invoices, "PlateNumber"));
      return this.uniqYears(this.invoices);
    },
    fi() {
      if (!this.mark) return;
      return this.tocurr(this.sumField(this.filteredInvoices, 'TotalValue'))
    },
    
   
    fiDate() {
      if (this.invoicingPeriodYear || this.invoicingPeriodMonth) {
        return this.tocurr(this.sumField(this.filteredInvoices.filter(e=>!['5.1', '5.2'].includes(e.InvoiceType)), 'TotalValue')-this.sumField(this.filteredInvoices.filter(e=>['5.1', '5.2'].includes(e.InvoiceType)), 'TotalValue'))
      }
      return null;
    },
  },
  data() {
    return {
      expanded: [],
      snackbar: false,
      snackText: "",
      diaitems: {},
      loading: true,
      balance: 0.0,
      search: '',
      sid: this.$route.params.id,
      invoices: [],
      filteredInvoices: [],
      invoicingPeriodYear: '',
      invoicingPeriodMonth: '',
      showFilters: true,
      paymentForm: {
          Id: null,
          Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          Remarks: null,
          PaymTerm: 1,
          TotalValue: 0,
       },
      months: [
        { text: 'Ιανουάριος', value: '01' },
        { text: 'Φεβρουάριος', value: '02' },
        { text: 'Μάρτιος', value: '03' },
        { text: 'Απρίλιος', value: '04' },
        { text: 'Μάιος', value: '05' },
        { text: 'Ιούνιος', value: '06' },
        { text: 'Ιούλιος', value: '07' },
        { text: 'Αύγουστος', value: '08' },
        { text: 'Σεπτέμβριος', value: '09' },
        { text: 'Οκτώβριος', value: '10' },
        { text: 'Νοέμβριος', value: '11' },
        { text: 'Δεκέμβριος', value: '12' }
      ],
      headers: [
          {
            text: 'Αρ. Τιμολογίου',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '5%',
          },
          { text: 'Ημερομηνία', value: 'Date', width: '10%',
          filter: (value) => {
            const currentYear = new Date().getFullYear().toString();
            const invoiceYear = value.slice(0, 4);
            const invoiceMonth = value.slice(5, 7);

            // Default to current year if only month is selected
            const selectedYear = this.invoicingPeriodYear || currentYear;
            const selectedMonth = this.invoicingPeriodMonth;

            if (!selectedYear && !selectedMonth) return true;
            if (selectedYear && !selectedMonth) return selectedYear === invoiceYear;
            if (!selectedYear && selectedMonth) return currentYear === invoiceYear && selectedMonth === invoiceMonth;
            return selectedYear === invoiceYear && selectedMonth === invoiceMonth;
            },
           },
          { text: 'Τυπος', value: 'InvoiceType' },
          { text: 'Σειρά', value: 'SeriesCode' },
          { text: 'Αριθμός', value: 'DocNumber' },
          { text: 'Καθαρή αξία', value: 'NetValue', align: 'end' },
          { text: 'ΦΠΑ', value: 'VatValue', align: 'end' },
          { text: 'Συνολο', value: 'TotalValue', align: 'end' },
          { text: 'Πληρωμή', value: 'PaymTerm.Desc', align: 'center' },
          // { text: 'ΑΑΔΕ ΜΑΡΚ', value: 'Mark', align: 'center' },
          { text: 'Actions', value: 'actions' },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/suppliers/invoices/'+this.$route.params.id);
        console.log(response);
        this.supplier = response.data;
        this.invoices = this.supplier.Invoices;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
    getFilteredInvoices (invos) {
       this.filteredInvoices = invos;
    },
     uniq(items, key) {
      //Store the unique
      let uniques = [];

      //Track the items added to the uniques
      let itemsFound = {};
      for (let val of items) {
        //If item is already added then move to the next item
        if (itemsFound[val[key]]) {
          continue;
        }

        //Else push it to the unique list
        uniques.push(val[key]);

        //Mark it as added
        itemsFound[val[key]] = true;
      }

      //Return the uniques
      return uniques;
    },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },

    uniqYears(items) {
      //Store the unique
      let uniques = [];

      //Track the items added to the uniques
      let itemsFound = {};
      let year = 0;
      for (let val of items) {
        year = val['Date'].slice(0,4);
        //console.log(year) //.getFullYear();
        //If item is already added then move to the next item
        if (itemsFound[val[year]]) {
          continue;
        }

        //Else push it to the unique list
        uniques.push(year);

        //Mark it as added
        itemsFound[year] = true;
      }

      //Return the uniques
      return uniques;
    },
      tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    
    showInvoice(item) {
    //console.log(item, this.timdialog)
     let path = "distributor-order-checkin"
        let params = {"invoiceId": item.Id}
        this.$router.push({"name": path, "params": params});
    //this.diaitems = item.line_items;
    //this.timdialog = true;
  },
  async createPayment(item) {
        let paym = _clone(this.paymentForm);
        paym.PaymTerm = 0;
        paym.Remarks = `Εξόφληση τιμολογίου ${item.SeriesCode}-${item.DocNumber}`
        paym.TotalValue = item.TotalValue;
        paym.Date = item.Date;
   
        var response = await this.$api.post(`/suppliers/debits/${this.sid}`, paym);
        if (response.status == 201) {
          paym.Id = response.data.Id;
          this.snackText = `Καταχωρήθηκε απόδειξη αξίας ${paym.TotalValue} € με αριθμό ${paym.Id} για το τιμολόγιο ${item.SeriesCode}-${item.DocNumber}.\n`;
          this.snackbar = true;
        } else {
          alert(response.data);
        }
      },
  
  async createPaymentAdmin(item) {
        let paym = _clone(this.paymentForm);
        paym.PaymTerm = 1;
        paym.Remarks = `Εξόφληση τιμολογίου ${item.SeriesCode}-${item.DocNumber}`
        paym.TotalValue = item.TotalValue;
        paym.Date = item.Date;
   
        var response = await this.$api.post(`/suppliers/debits/${this.sid}`, paym);
        if (response.status == 201) {
          paym.Id = response.data.Id;
          this.snackText = `Καταχωρήθηκε απόδειξη αξίας ${paym.TotalValue} € με αριθμό ${paym.Id} για το τιμολόγιο ${item.SeriesCode}-${item.DocNumber}.\n`;
          this.snackbar = true;
        } else {
          alert(response.data);
        }
      },
  close () {
        this.timdialog = false
  }

  }
}
</script>
